function ExcelUploadModal({
  modalId,
  title,
  isEditMode,
  closeModal,
  setView,
  view,
  fileInputRef,
  handleExcelFileChange,
  handleExcelSubmit,
  message,
}) {
  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-labelledby="newUserModalLabel"
      aria-hidden="true"
    >
      <div
        className={`modal-dialog ${
          view === "manual"
            ? "modal-fullscreen"
            : "modal-dialog-centered modal-dialog-scrollable modal-md"
        }`}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="newUserModalLabel">
              {isEditMode ? "Edit Donor" : title}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                closeModal();
                setView("excel");
              }}
            ></button>
          </div>

          <div className="modal-body">
            {view === "excel" && (
              <>
                <div className="mb-3">
                  <label htmlFor="excelUpload" className="form-label">
                    Upload Excel File (.xlsx)
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="excelUpload"
                    accept=".xlsx"
                    ref={fileInputRef}
                    onChange={handleExcelFileChange}
                  />

                  <button
                    className="btn btn-success mt-3"
                    onClick={handleExcelSubmit}
                  >
                    Upload
                  </button>
                  {message && <div className="mt-2">{message}</div>}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExcelUploadModal;
